import { isArray } from 'lodash';

export function toFormData<T>(formValue: T) {
  const formData = new FormData();

  for (const key of Object.keys(formValue)) {
    const value = formValue[key];

    if (isArray(value)) {
      formValue[key].forEach((item: any) => {
        formData.append(`${key}`, item);
      });
    } else {
      formData.append(key, value);
    }
  }

  return formData;
}
